module.exports = __webpack_public_path__ + "icon-filter-white.svg?3db8ed88e22478a48740bee853549274";